<template>
  <div class="section">
    <div id="alertModal" class="modal fade" tabindex="-1" role="dialog" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button v-if="!isLoading" type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
            <h4 id="forgot_ModalLabel" class="modal-title"><i class="fa fa-bullhorn mr-5"></i>{{'news_modal' | translate($parent.language)}}</h4>
          </div>
          <div class="modal-body notification">
            <template v-for="alert in alerts">
              <b-alert :show="alert.dismiss" :variant="alert.type">
                <h4>
                  <i :class="['icon', alert.icon]"></i>
                  {{alert.title}}</h4>
                <p class="message">
                 <!-- <span v-for="line in alert.message">{{line}} <template v-if="alert.message.length > 1"><br/></template></span> -->
                  <span v-html="alert.message"></span>
                </p>
                <i>-by Customer Service on {{alert.date}}</i>
              </b-alert>
              <div class="checkbox">
                <label><input type="checkbox" :disabled="isLoading" @click="update(alert.message_id)" v-model="checked" class="mr-5"/>{{'dont_show' | translate($parent.language)}}<i class="fa fa-spinner fa-spin ml-5" v-if="isLoading"></i></label>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <button id="openModal" hidden data-toggle="modal" data-target="#alertModal"></button>
  </div>
</template>
<script>
export default {
  data () {
    return {
      alerts: [],
      news: {},
      isLoading: false,
      checked: false
    }
  },
  methods: {
    update (id) {
      this.isLoading = true
      API.put(`/messages/${id}/hide`)
        .then(response => {
          this.isLoading = false
          $('#alertModal').modal('toggle')
        })
    }
  },
  mounted () {
    let arr = []
    API.get('/messages')
      .then(response => {
        if (response.data && response.data.message) {
          // response.data.message = response.data.message.split('\n')
          if (response.data.is_active) {
            response.data.icon = response.data.status === 'info' ? 'fa fa-info-circle' : 'fa fa-warning'
            let alert = {
              type: response.data.status,
              icon: response.data.icon,
              dismiss: true,
              message: response.data.message,
              title: response.data.title,
              date: moment(response.data.created_at, 'DD.MM.YYYY hh:mm:ss').format('MMMM Do YYYY, h:mm a'),
              message_id: response.data.id
            }
            arr.push(alert)
          }
          this.alerts = arr.reverse()
          if (this.alerts.length > 0) {
            $('#openModal').click()
          }
        }
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/NewsComponent.vue